(() => {
  const wishlistKey = 'dollz-wishlist';

  const root =
    window.Shopify &&
    window.Shopify.routes &&
    window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

  const SPECIAL = {
    flaunt: 'dr-c-tuna-flaunt-it-body-sculpting-gel',
    vest: 'snatch-gang-vest',
    belt: 'sweat-belt',
    tea: 'nutriplus-cleanse-reset-crisp-watermelon-1'
  };

  let quickViewProduct = null;
  let quickViewExtras = {};
  let quickViewUpsells = [];
  let lastQuickViewTrigger = null;

  /* =====================================================
     HELPERS
     ===================================================== */

  const escapeHtml = (value = '') => {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  };

  const normalizeImage = (url) => {
    if (!url) return '';
    return url.startsWith('//') ? `https:${url}` : url;
  };

  const getProductImage = (product) => {
    if (!product) return '';

    return normalizeImage(
      product.featured_image ||
      (
        product.images &&
        product.images.length
          ? product.images[0]
          : ''
      )
    );
  };

  const formatMoney = (cents) => {
    const amount = Number(cents || 0) / 100;

    try {
      return new Intl.NumberFormat(
        document.documentElement.lang || 'en-US',
        {
          style: 'currency',
          currency:
            window.Shopify &&
            window.Shopify.currency &&
            window.Shopify.currency.active
              ? window.Shopify.currency.active
              : 'USD'
        }
      ).format(amount);
    } catch (error) {
      return `$${amount.toFixed(2)}`;
    }
  };

  const fetchProduct = async (handle) => {
    const response = await fetch(
      `${root}products/${encodeURIComponent(handle)}.js`,
      {
        headers: {
          Accept: 'application/json'
        }
      }
    );

    if (!response.ok) {
      throw new Error(`Unable to load ${handle}.`);
    }

    return response.json();
  };

  const firstAvailableVariant = (product) => {
    if (!product || !product.variants) return null;

    return (
      product.variants.find((variant) => variant.available) ||
      product.variants[0] ||
      null
    );
  };

  
/* =====================================================
   WISHLIST
   ===================================================== */

const getWishlist = () => {
  try {
    return JSON.parse(
      localStorage.getItem(wishlistKey) || '[]'
    );
  } catch (error) {
    return [];
  }
};

const saveWishlist = (items) => {
  localStorage.setItem(
    wishlistKey,
    JSON.stringify(items)
  );
};

const updateWishlist = () => {
  const saved = getWishlist();

  document
    .querySelectorAll('[data-wishlist-handle]')
    .forEach((button) => {
      const active = saved.includes(
        button.dataset.wishlistHandle
      );

      button.classList.toggle(
        'is-saved',
        active
      );

      button.setAttribute(
        'aria-pressed',
        String(active)
      );
    });

  /* HEADER WISHLIST COUNT */
  document
    .querySelectorAll('[data-wishlist-count]')
    .forEach((counter) => {
      counter.textContent = saved.length;

      counter.classList.toggle(
        'is-visible',
        saved.length > 0
      );
    });
};
/* =====================================================
   WISHLIST TOAST
   ===================================================== */

const showWishlistToast = (message) => {
  let toast = document.querySelector(
    '[data-wishlist-toast]'
  );

  if (!toast) {
    toast = document.createElement('div');

    toast.className = 'wishlist-toast';
    toast.dataset.wishlistToast = '';

    toast.setAttribute(
      'role',
      'status'
    );

    toast.setAttribute(
      'aria-live',
      'polite'
    );

    document.body.appendChild(toast);
  }

  toast.textContent = message;

  toast.classList.remove('is-visible');

  requestAnimationFrame(() => {
    toast.classList.add('is-visible');
  });

  clearTimeout(
    window.dollzWishlistToastTimer
  );

  window.dollzWishlistToastTimer =
    setTimeout(() => {
      toast.classList.remove('is-visible');
    }, 2200);
};

  /* =====================================================
     PRODUCT GALLERY
     ===================================================== */

  const setupGalleries = () => {
    document
      .querySelectorAll('[data-product-gallery]')
      .forEach((gallery) => {
        if (gallery.dataset.galleryReady === 'true') {
          return;
        }

        gallery.dataset.galleryReady = 'true';

        gallery.addEventListener('click', (event) => {
          const button = event.target.closest(
            '[data-gallery-thumb]'
          );

          if (!button) return;

          const target = button.dataset.galleryThumb;

          gallery
            .querySelectorAll('[data-gallery-slide]')
            .forEach((slide) => {
              slide.classList.toggle(
                'is-active',
                slide.dataset.gallerySlide === target
              );
            });

          gallery
            .querySelectorAll('[data-gallery-thumb]')
            .forEach((thumb) => {
              const active = thumb === button;

              thumb.classList.toggle(
                'is-active',
                active
              );

              thumb.setAttribute(
                'aria-pressed',
                String(active)
              );
            });
        });
      });
  };

  /* =====================================================
     QUICK VIEW MODAL
     ===================================================== */

  const createQuickView = () => {
    if (
      document.querySelector(
        '[data-dollz-quick-view]'
      )
    ) {
      return;
    }

    const wrapper = document.createElement('div');

    wrapper.className = 'dollz-quick-view';
    wrapper.dataset.dollzQuickView = '';
    wrapper.hidden = true;

    wrapper.innerHTML = `
      <div
        class="dollz-quick-view__backdrop"
        data-quick-view-close
      ></div>

      <div
        class="dollz-quick-view__panel"
        role="dialog"
        aria-modal="true"
        aria-labelledby="DollzQuickViewTitle"
        tabindex="-1"
      >
        <button
          type="button"
          class="dollz-quick-view__close"
          data-quick-view-close
          aria-label="Close quick view"
        >
          ×
        </button>

        <div
          class="dollz-quick-view__content"
          data-quick-view-content
        ></div>
      </div>
    `;

    document.body.appendChild(wrapper);
  };

  const getQuickView = () => {
    return document.querySelector(
      '[data-dollz-quick-view]'
    );
  };

  const closeQuickView = () => {
    const modal = getQuickView();

    if (!modal || modal.hidden) return;

    modal.classList.remove('is-open');

    document.body.classList.remove(
      'quick-view-open'
    );

    window.setTimeout(() => {
      modal.hidden = true;

      const content = modal.querySelector(
        '[data-quick-view-content]'
      );

      if (content) {
        content.innerHTML = '';
      }

      quickViewProduct = null;
      quickViewExtras = {};

      if (lastQuickViewTrigger) {
        lastQuickViewTrigger.focus();
      }
    }, 220);
  };

  const openQuickViewShell = () => {
    createQuickView();

    const modal = getQuickView();

    modal.hidden = false;

    requestAnimationFrame(() => {
      modal.classList.add('is-open');
    });

    document.body.classList.add(
      'quick-view-open'
    );

    const panel = modal.querySelector(
      '.dollz-quick-view__panel'
    );

    if (panel) {
      panel.focus();
    }
  };

  const renderLoading = () => {
    const modal = getQuickView();

    if (!modal) return;

    const content = modal.querySelector(
      '[data-quick-view-content]'
    );

    content.innerHTML = `
      <div class="dollz-quick-view__loading">
        <span>Loading your Dollz pick...</span>
      </div>
    `;
  };

  /* =====================================================
     NORMAL PRODUCT OPTIONS
     ===================================================== */

  const getOptionValues = (
    product,
    optionIndex
  ) => {
    const values = [];

    product.variants.forEach((variant) => {
      const value = variant.options[optionIndex];

      if (
        value &&
        !values.includes(value)
      ) {
        values.push(value);
      }
    });

    return values;
  };

  const renderOptions = (product) => {
    if (
      !product.options ||
      !product.options.length
    ) {
      return '';
    }

    return product.options
      .map((option, index) => {
        const optionName =
          typeof option === 'string'
            ? option
            : option.name;

        if (
          optionName === 'Title' &&
          product.variants.length === 1
        ) {
          return '';
        }

        const values = getOptionValues(
          product,
          index
        );

        return `
          <fieldset
            class="dollz-quick-view__option"
            data-option-index="${index}"
          >
            <legend>
              ${escapeHtml(optionName)}
            </legend>

            <div class="dollz-quick-view__values">
              ${values
                .map((value, valueIndex) => `
                  <button
                    type="button"
                    class="dollz-quick-view__value${
                      valueIndex === 0
                        ? ' is-selected'
                        : ''
                    }"
                    data-option-value="${escapeHtml(value)}"
                    aria-pressed="${
                      valueIndex === 0
                        ? 'true'
                        : 'false'
                    }"
                  >
                    ${escapeHtml(value)}
                  </button>
                `)
                .join('')}
            </div>
          </fieldset>
        `;
      })
      .join('');
  };

  const findSelectedVariant = (
    modal,
    product
  ) => {
    const selections = [];

    modal
      .querySelectorAll('[data-option-index]')
      .forEach((group) => {
        const selected = group.querySelector(
          '.dollz-quick-view__value.is-selected'
        );

        if (selected) {
          selections[
            Number(group.dataset.optionIndex)
          ] = selected.dataset.optionValue;
        }
      });

    if (product.variants.length === 1) {
      return product.variants[0];
    }

    return (
      product.variants.find((variant) =>
        variant.options.every(
          (value, index) =>
            selections[index] === value
        )
      ) || null
    );
  };

  const updateOptionAvailability = (
    modal,
    product
  ) => {
    modal
      .querySelectorAll('[data-option-index]')
      .forEach((group) => {
        const optionIndex = Number(
          group.dataset.optionIndex
        );

        group
          .querySelectorAll('[data-option-value]')
          .forEach((button) => {
            const value =
              button.dataset.optionValue;

            const possible =
              product.variants.some((variant) => {
                if (!variant.available) {
                  return false;
                }

                if (
                  variant.options[optionIndex] !== value
                ) {
                  return false;
                }

                for (
                  let i = 0;
                  i < optionIndex;
                  i++
                ) {
                  const earlier =
                    modal.querySelector(
                      `[data-option-index="${i}"] .dollz-quick-view__value.is-selected`
                    );

                  if (
                    earlier &&
                    variant.options[i] !==
                      earlier.dataset.optionValue
                  ) {
                    return false;
                  }
                }

                return true;
              });

            button.disabled = !possible;

            button.classList.toggle(
              'is-unavailable',
              !possible
            );
          });
      });
  };

  const selectFirstAvailableCombination = (
    modal,
    product
  ) => {
    const variant =
      product.variants.find(
        (item) => item.available
      ) || product.variants[0];

    if (!variant) return;

    variant.options.forEach(
      (value, index) => {
        const group = modal.querySelector(
          `[data-option-index="${index}"]`
        );

        if (!group) return;

        group
          .querySelectorAll(
            '[data-option-value]'
          )
          .forEach((button) => {
            const active =
              button.dataset.optionValue === value;

            button.classList.toggle(
              'is-selected',
              active
            );

            button.setAttribute(
              'aria-pressed',
              String(active)
            );
          });
      }
    );
  };

  /* =====================================================
     ROUTINE VARIANT SELECT
     ===================================================== */

  const variantSelectHtml = (
    product,
    dataAttribute,
    label
  ) => {
    if (!product) return '';

  const preferredIds =
  product._preferredVariantIds || [];

const variants =
  preferredIds.length
    ? (product.variants || []).filter((variant) =>
        preferredIds.includes(String(variant.id))
      )
    : (product.variants || []);

    return `
      <div class="dollz-qv-routine__variant">
        <label>${escapeHtml(label)}</label>

        <select ${dataAttribute}>
          ${variants
            .map((variant) => `
              <option
                value="${variant.id}"
                ${variant.available ? '' : 'disabled'}
              >
                ${escapeHtml(variant.title)}
                — ${formatMoney(variant.price)}
                ${variant.available ? '' : ' — Sold Out'}
              </option>
            `)
            .join('')}
        </select>
      </div>
    `;
  };

  /* =====================================================
     TEA / WELLNESS CARD WITH REAL PHOTO
     ===================================================== */

  const renderTeaAddon = () => {
    const tea = quickViewExtras.tea;

    if (!tea) return '';

    const teaPhoto = getProductImage(tea);

    return `
      <fieldset
        class="dollz-qv-routine__section dollz-qv-routine__section--wellness"
      >
        <legend>
          Add Wellness Support
        </legend>

        <label class="dollz-qv-routine__choice">

          <input
            type="checkbox"
            data-qv-addon="tea"
          >

          ${
            teaPhoto
              ? `
                <span class="dollz-qv-routine__photo">
                  <img
                    src="${escapeHtml(teaPhoto)}"
                    alt="${escapeHtml(tea.title)}"
                    loading="lazy"
                  >
                </span>
              `
              : ''
          }

          <span class="dollz-qv-routine__copy">
            <strong>
              ${escapeHtml(tea.title)}
            </strong>

            <small>
              From ${formatMoney(tea.price)}
            </small>
          </span>

          <span
            class="dollz-qv-routine__check"
            aria-hidden="true"
          ></span>

        </label>

        <div
          class="dollz-qv-routine__variant-panel"
          data-qv-addon-wrap="tea"
          hidden
        >
          ${variantSelectHtml(
            tea,
            'data-qv-tea-variant',
            'Choose supply'
          )}
        </div>

      </fieldset>
    `;
  };

  /* =====================================================
     FLAUNT IT ROUTINE
     REAL VEST + BELT PHOTOS
     ===================================================== */

  const renderFlauntRoutine = () => {
    const vest = quickViewExtras.vest;
    const belt = quickViewExtras.belt;

    const vestPhoto =
      getProductImage(vest);

    const beltPhoto =
      getProductImage(belt);

    return `
      <div
        class="dollz-qv-routine"
        data-qv-routine="flaunt"
      >

        <p class="routine-kicker">
          PAIR IT. SWEAT IT. RESET IT.
        </p>

        <h3>
          Complete Your Routine 🔥
        </h3>

        <p class="routine-builder__intro">
          Pair Flaunt It with your favorite shaping gear and wellness support.
        </p>

        <fieldset
          class="dollz-qv-routine__section"
        >
          <legend>
            1. Choose Your Shaping Gear
          </legend>

          ${
            vest
              ? `
                <label
                  class="dollz-qv-routine__choice"
                >

                  <input
                    type="radio"
                    name="qv_routine_gear"
                    value="vest"
                    data-qv-gear
                  >

                  ${
                    vestPhoto
                      ? `
                        <span
                          class="dollz-qv-routine__photo"
                        >
                          <img
                            src="${escapeHtml(vestPhoto)}"
                            alt="${escapeHtml(vest.title)}"
                            loading="lazy"
                          >
                        </span>
                      `
                      : ''
                  }

                  <span
                    class="dollz-qv-routine__copy"
                  >
                    <strong>
                      ${escapeHtml(vest.title)}
                    </strong>

                    <small>
                      From ${formatMoney(vest.price)}
                    </small>
                  </span>

                  <span
                    class="dollz-qv-routine__check"
                    aria-hidden="true"
                  ></span>

                </label>

                <div
                  class="dollz-qv-routine__variant-panel"
                  data-qv-gear-wrap="vest"
                  hidden
                >
                  ${variantSelectHtml(
                    vest,
                    'data-qv-vest-variant',
                    'Choose size / color'
                  )}
                </div>
              `
              : ''
          }

          ${
            belt
              ? `
                <label
                  class="dollz-qv-routine__choice"
                >

                  <input
                    type="radio"
                    name="qv_routine_gear"
                    value="belt"
                    data-qv-gear
                  >

                  ${
                    beltPhoto
                      ? `
                        <span
                          class="dollz-qv-routine__photo"
                        >
                          <img
                            src="${escapeHtml(beltPhoto)}"
                            alt="${escapeHtml(belt.title)}"
                            loading="lazy"
                          >
                        </span>
                      `
                      : ''
                  }

                  <span
                    class="dollz-qv-routine__copy"
                  >
                    <strong>
                      ${escapeHtml(belt.title)}
                    </strong>

                    <small>
                      From ${formatMoney(belt.price)}
                    </small>
                  </span>

                  <span
                    class="dollz-qv-routine__check"
                    aria-hidden="true"
                  ></span>

                </label>

                <div
                  class="dollz-qv-routine__variant-panel"
                  data-qv-gear-wrap="belt"
                  hidden
                >
                  ${variantSelectHtml(
                    belt,
                    'data-qv-belt-variant',
                    'Choose option'
                  )}
                </div>
              `
              : ''
          }

          <label
            class="dollz-qv-routine__choice dollz-qv-routine__choice--none"
          >

            <input
              type="radio"
              name="qv_routine_gear"
              value="none"
              data-qv-gear
              checked
            >

            <span
              class="dollz-qv-routine__none-icon"
              aria-hidden="true"
            >
              ✕
            </span>

            <span
              class="dollz-qv-routine__copy"
            >
              <strong>
                No Thanks
              </strong>

              <small>
                Flaunt It only
              </small>
            </span>

            <span
              class="dollz-qv-routine__check"
              aria-hidden="true"
            ></span>

          </label>

        </fieldset>

        ${renderTeaAddon()}

      </div>
    `;
  };

  /* =====================================================
     VEST / BELT ROUTINE
     REAL FLAUNT PHOTO
     ===================================================== */

  const renderShaperRoutine = () => {
    const flaunt =
      quickViewExtras.flaunt;

    const flauntPhoto =
      getProductImage(flaunt);

    return `
      <div
        class="dollz-qv-routine"
        data-qv-routine="shaper"
      >

        <p class="routine-kicker">
          BUILD THE FULL ROUTINE
        </p>

        <h3>
          Complete Your Routine 🔥
        </h3>

        <p class="routine-builder__intro">
          Add Flaunt It and wellness support to your shaping routine.
        </p>

        ${
          flaunt
            ? `
              <fieldset
                class="dollz-qv-routine__section"
              >
                <legend>
                  1. Add Flaunt It
                </legend>

                <label
                  class="dollz-qv-routine__choice"
                >

                  <input
                    type="checkbox"
                    data-qv-addon="flaunt"
                  >

                  ${
                    flauntPhoto
                      ? `
                        <span
                          class="dollz-qv-routine__photo"
                        >
                          <img
                            src="${escapeHtml(flauntPhoto)}"
                            alt="${escapeHtml(flaunt.title)}"
                            loading="lazy"
                          >
                        </span>
                      `
                      : ''
                  }

                  <span
                    class="dollz-qv-routine__copy"
                  >
                    <strong>
                      ${escapeHtml(flaunt.title)}
                    </strong>

                    <small>
                      ${formatMoney(flaunt.price)}
                    </small>
                  </span>

                  <span
                    class="dollz-qv-routine__check"
                    aria-hidden="true"
                  ></span>

                </label>

              </fieldset>
            `
            : ''
        }

        ${renderTeaAddon()}

      </div>
    `;
  };

  const renderSpecialRoutine = (
    product
  ) => {
    if (
      product.handle === SPECIAL.flaunt
    ) {
      return renderFlauntRoutine();
    }

    if (
      product.handle === SPECIAL.vest ||
      product.handle === SPECIAL.belt
    ) {
      return renderShaperRoutine();
    }

    return '';
  };
const renderDynamicUpsells = () => {
  if (!quickViewUpsells.length) return '';

  return `
    <div class="dollz-qv-routine" data-qv-routine="dynamic">
      <p class="routine-kicker">
        COMPLETE THE LOOK
      </p>

      <h3>
        You May Want These Too ♡
      </h3>

      <p class="routine-builder__intro">
        Add any of these to your order.
      </p>

      <fieldset class="dollz-qv-routine__section">
        ${quickViewUpsells.map((product, index) => {
        const preferredVariant =
  product._preferredVariantIds?.length
    ? (product.variants || []).find(
        (variant) =>
          String(variant.id) ===
          String(product._preferredVariantIds[0])
      )
    : null;

const image =
  preferredVariant?.featured_image?.src
    ? normalizeImage(preferredVariant.featured_image.src)
    : getProductImage(product);
          const productUrl =
            product.url ||
            `${root}products/${product.handle}`;

          return `
            <div class="dollz-qv-dynamic">
              <label class="dollz-qv-routine__choice">
                <input
                  type="checkbox"
                  data-qv-dynamic-addon="${index}"
                >

                ${
                  image
                    ? `
                      <span class="dollz-qv-routine__photo">
                        <a
                          href="${escapeHtml(productUrl)}"
                          target="_blank"
                          rel="noopener"
                          onclick="event.stopPropagation();"
                        >
                          <img
                            src="${escapeHtml(image)}"
                            alt="${escapeHtml(product.title)}"
                            loading="lazy"
                          >
                        </a>
                      </span>
                    `
                    : ''
                }

                <span class="dollz-qv-routine__copy">
                  <strong>
                    ${escapeHtml(product.title)}
                  </strong>

                  <small>
                    From ${formatMoney(product.price)}
                  </small>

                  <a
                    href="${escapeHtml(productUrl)}"
                    target="_blank"
                    rel="noopener"
                    onclick="event.stopPropagation();"
                  >
                    View Product →
                  </a>
                </span>

                <span
                  class="dollz-qv-routine__check"
                  aria-hidden="true"
                ></span>
              </label>

              <div
                class="dollz-qv-routine__variant-panel"
                data-qv-dynamic-wrap="${index}"
                hidden
              >
                ${variantSelectHtml(
                  product,
                  `data-qv-dynamic-variant="${index}"`,
                  'Choose option'
                )}
              </div>
            </div>
          `;
        }).join('')}
      </fieldset>
    </div>
  `;
};
  /* =====================================================
     MAIN VARIANT UPDATE
     ===================================================== */

  const updateQuickViewVariant = () => {
    const modal = getQuickView();

    if (
      !modal ||
      !quickViewProduct
    ) {
      return;
    }

    updateOptionAvailability(
      modal,
      quickViewProduct
    );

    const variant =
      findSelectedVariant(
        modal,
        quickViewProduct
      );

    const price =
      modal.querySelector(
        '[data-quick-view-price]'
      );

    const button =
      modal.querySelector(
        '[data-quick-view-add]'
      );

    const image =
      modal.querySelector(
        '[data-quick-view-image]'
      );

    if (variant) {
      if (price) {
        price.textContent =
          formatMoney(variant.price);
      }

      if (button) {
        button.dataset.variantId =
          variant.id;

        button.disabled =
          !variant.available;

        button.textContent =
          variant.available
            ? 'Add to Bag'
            : 'Sold Out';
      }

      if (
        image &&
        variant.featured_image &&
        variant.featured_image.src
      ) {
        image.src =
          normalizeImage(
            variant.featured_image.src
          );
      }
    } else if (button) {
      button.removeAttribute(
        'data-variant-id'
      );

      button.disabled = true;

      button.textContent =
        'Unavailable';
    }
  };

  /* =====================================================
     QUICK VIEW PRODUCT
     ===================================================== */

  const renderQuickViewProduct = (
    product
  ) => {
    const modal = getQuickView();

    if (!modal) return;

    quickViewProduct = product;

    const content =
      modal.querySelector(
        '[data-quick-view-content]'
      );

    const image =
      getProductImage(product);

    const productUrl =
      product.url ||
      `${root}products/${product.handle}`;

    content.innerHTML = `
      <div
        class="dollz-quick-view__layout"
      >

        <div
          class="dollz-quick-view__media"
        >
          ${
            image
              ? `
                <a
                  href="${escapeHtml(productUrl)}"
                  class="dollz-quick-view__image-link"
                >
                  <img
                    src="${escapeHtml(image)}"
                    alt="${escapeHtml(product.title)}"
                    class="dollz-quick-view__image"
                    data-quick-view-image
                  >
                </a>
              `
              : ''
          }
        </div>

        <div
          class="dollz-quick-view__details"
        >

          <p
            class="dollz-quick-view__eyebrow"
          >
            ${
              product.type
                ? escapeHtml(product.type)
                : 'Fashion Dollz Boutique'
            }
          </p>

          <h2
            id="DollzQuickViewTitle"
            class="dollz-quick-view__title"
          >
            ${escapeHtml(product.title)}
          </h2>

          <p
            class="dollz-quick-view__price"
            data-quick-view-price
          >
            ${formatMoney(product.price)}
          </p>

          <div
            class="dollz-quick-view__options"
          >
            ${renderOptions(product)}
          </div>

          ${
  renderSpecialRoutine(product) ||
  renderDynamicUpsells()
}

          <div
            class="dollz-quick-view__quantity"
          >
            <span>
              Quantity
            </span>

            <div
              class="dollz-quick-view__quantity-control"
            >
              <button
                type="button"
                data-quick-view-qty-minus
                aria-label="Decrease quantity"
              >
                −
              </button>

              <input
                type="number"
                value="1"
                min="1"
                inputmode="numeric"
                data-quick-view-quantity
                aria-label="Quantity"
              >

              <button
                type="button"
                data-quick-view-qty-plus
                aria-label="Increase quantity"
              >
                +
              </button>
            </div>
          </div>

          <button
            type="button"
            class="button dollz-quick-view__add"
            data-quick-view-add
          >
            Add to Bag
          </button>

          <div
            class="dollz-quick-view__message"
            data-quick-view-message
            aria-live="polite"
          ></div>

          <a
            href="${escapeHtml(productUrl)}"
            class="dollz-quick-view__details-link"
          >
            View Full Details →
          </a>

        </div>

      </div>
    `;

    const mainImage =
  normalizeImage(
    product.featured_image ||
    (
      product.images &&
      product.images.length
        ? product.images[0]
        : ''
    )
  );

const preferredVariant =
  product.variants.find((variant) => {
    if (
      !variant.available ||
      !variant.featured_image ||
      !variant.featured_image.src
    ) {
      return false;
    }

    return (
      normalizeImage(
        variant.featured_image.src
      ).split('?')[0] ===
      mainImage.split('?')[0]
    );
  });

const startingVariant =
  preferredVariant ||
  product.variants.find(
    (variant) => variant.available
  );

if (startingVariant) {
  startingVariant.options.forEach(
    (value, index) => {
      const fieldset =
        modal.querySelector(
          `[data-option-index="${index}"]`
        );

      if (!fieldset) return;

      const buttons =
        fieldset.querySelectorAll(
          '[data-option-value]'
        );

      buttons.forEach((button) => {
        const selected =
          button.dataset.optionValue === value;

        button.classList.toggle(
          'is-selected',
          selected
        );

        button.setAttribute(
          'aria-pressed',
          selected ? 'true' : 'false'
        );
      });
    }
  );
} else {
  selectFirstAvailableCombination(
    modal,
    product
  );
}

initializeSpecialRoutine();

updateQuickViewVariant();
  };

  /* =====================================================
     ROUTINE BEHAVIOR
     ===================================================== */

  const initializeSpecialRoutine = () => {
    const modal = getQuickView();

    if (!modal) return;

    modal
      .querySelectorAll(
        '[data-qv-vest-variant], [data-qv-belt-variant], [data-qv-tea-variant]'
      )
      .forEach((select) => {
        const first =
          Array.from(
            select.options
          ).find(
            (option) =>
              !option.disabled
          );

        if (first) {
          select.value = first.value;
        }
      });

    syncSpecialRoutine();
  };

  const syncSpecialRoutine = () => {
    const modal = getQuickView();

    if (!modal) return;

    const selectedGear =
      modal.querySelector(
        '[data-qv-gear]:checked'
      );

    const vestWrap =
      modal.querySelector(
        '[data-qv-gear-wrap="vest"]'
      );

    const beltWrap =
      modal.querySelector(
        '[data-qv-gear-wrap="belt"]'
      );

    if (vestWrap) {
      vestWrap.hidden =
        !selectedGear ||
        selectedGear.value !== 'vest';
    }

    if (beltWrap) {
      beltWrap.hidden =
        !selectedGear ||
        selectedGear.value !== 'belt';
    }

    modal
      .querySelectorAll(
        '[data-qv-addon]'
      )
      .forEach((toggle) => {
        const type =
          toggle.dataset.qvAddon;

        const wrap =
          modal.querySelector(
            `[data-qv-addon-wrap="${type}"]`
          );

        if (wrap) {
          wrap.hidden =
            !toggle.checked;
        }
      });
         
  modal
    .querySelectorAll(
      '[data-qv-dynamic-addon]'
    )
    .forEach((toggle) => {
      const index =
        toggle.dataset.qvDynamicAddon;

      const wrap =
        modal.querySelector(
          `[data-qv-dynamic-wrap="${index}"]`
        );

      if (wrap) {
        wrap.hidden = !toggle.checked;
      }
    });
};

  /* =====================================================
     LOAD EXTRA PRODUCTS
     ===================================================== */

  const loadQuickViewExtras = async (
    handle
  ) => {
    quickViewExtras = {};

    if (handle === SPECIAL.flaunt) {
      const results =
        await Promise.all([
          fetchProduct(SPECIAL.vest)
            .catch(() => null),

          fetchProduct(SPECIAL.belt)
            .catch(() => null),

          fetchProduct(SPECIAL.tea)
            .catch(() => null)
        ]);

      quickViewExtras.vest =
        results[0];

      quickViewExtras.belt =
        results[1];

      quickViewExtras.tea =
        results[2];
    }

    if (
      handle === SPECIAL.vest ||
      handle === SPECIAL.belt
    ) {
      const results =
        await Promise.all([
          fetchProduct(SPECIAL.flaunt)
            .catch(() => null),

          fetchProduct(SPECIAL.tea)
            .catch(() => null)
        ]);

      quickViewExtras.flaunt =
        results[0];

      quickViewExtras.tea =
        results[1];
    }
  };

  /* =====================================================
     OPEN QUICK VIEW
     ===================================================== */

  const openQuickView = async (
  handle,
  trigger
) => {
  if (!handle) return;

  lastQuickViewTrigger = trigger;

  openQuickViewShell();
  renderLoading();

  try {
    const product =
      await fetchProduct(handle);

    await loadQuickViewExtras(handle);

    const upsellHandles = (
      trigger &&
      trigger.dataset.upsellHandles
        ? trigger.dataset.upsellHandles
        : ''
    )
      .split(',')
      .map((item) => item.trim())
      .filter(Boolean);
const preferredVariantIds = (
  trigger &&
  trigger.dataset.upsellPreferredVariantIds
    ? trigger.dataset.upsellPreferredVariantIds
    : ''
)
  .split(',')
  .map((item) => item.trim())
  .filter(Boolean);
    quickViewUpsells = [];

    if (
      handle !== SPECIAL.flaunt &&
      handle !== SPECIAL.vest &&
      handle !== SPECIAL.belt &&
      upsellHandles.length
    ) {
      const results = await Promise.all(
        upsellHandles.map((upsellHandle) =>
          fetchProduct(upsellHandle)
            .catch(() => null)
        )
      );

      quickViewUpsells = results
  .filter(Boolean)
  .map((upsellProduct) => {
    const matchingIds = preferredVariantIds.filter((id) =>
      (upsellProduct.variants || []).some(
        (variant) => String(variant.id) === String(id)
      )
    );

    return {
      ...upsellProduct,
      _preferredVariantIds: matchingIds
    };
  });
    }

    renderQuickViewProduct(product);

  } catch (error) {
    console.error(
      'Fashion Dollz Quick View:',
      error
    );

    const modal = getQuickView();

    if (!modal) return;

    const content =
      modal.querySelector(
        '[data-quick-view-content]'
      );

    content.innerHTML = `
      <div class="dollz-quick-view__error">
        <h2>
          We couldn't load this Dollz pick.
        </h2>

        <p>
          Please try again or open the full product page.
        </p>
      </div>
    `;
  }
};

  /* =====================================================
     BUILD CART ITEMS
     ===================================================== */

  const buildQuickViewCartItems = (
    button,
    quantity
  ) => {
    const modal = getQuickView();

    if (
      !modal ||
      !quickViewProduct
    ) {
      return {
        items: [],
        error:
          'Please choose an available option.'
      };
    }

    const mainVariantId =
      button.dataset.variantId;

    if (!mainVariantId) {
      return {
        items: [],
        error:
          'Please choose an available option.'
      };
    }

    const items = [
      {
        id: Number(mainVariantId),
        quantity
      }
    ];

    /* FLAUNT IT: VEST OR BELT */

    if (
      quickViewProduct.handle ===
      SPECIAL.flaunt
    ) {
      const gear =
        modal.querySelector(
          '[data-qv-gear]:checked'
        );

      if (
        gear &&
        gear.value === 'vest'
      ) {
        const select =
          modal.querySelector(
            '[data-qv-vest-variant]'
          );

        if (
          !select ||
          !select.value ||
          select.options[
            select.selectedIndex
          ].disabled
        ) {
          return {
            items: [],
            error:
              'Please choose an available Sweat Vest size/color.'
          };
        }

        items.push({
          id: Number(select.value),
          quantity: 1
        });
      }

      if (
        gear &&
        gear.value === 'belt'
      ) {
        const select =
          modal.querySelector(
            '[data-qv-belt-variant]'
          );

        if (
          !select ||
          !select.value ||
          select.options[
            select.selectedIndex
          ].disabled
        ) {
          return {
            items: [],
            error:
              'Please choose an available Sweat Belt option.'
          };
        }

        items.push({
          id: Number(select.value),
          quantity: 1
        });
      }
    }

    /* VEST/BELT: OPTIONAL FLAUNT */

    if (
      quickViewProduct.handle ===
        SPECIAL.vest ||
      quickViewProduct.handle ===
        SPECIAL.belt
    ) {
      const flauntToggle =
        modal.querySelector(
          '[data-qv-addon="flaunt"]'
        );

      if (
        flauntToggle &&
        flauntToggle.checked &&
        quickViewExtras.flaunt
      ) {
        const flauntVariant =
          firstAvailableVariant(
            quickViewExtras.flaunt
          );

        if (
          flauntVariant &&
          flauntVariant.available
        ) {
          items.push({
            id: Number(
              flauntVariant.id
            ),
            quantity: 1
          });
        }
      }
    }

    /* OPTIONAL TEA */

    const teaToggle =
      modal.querySelector(
        '[data-qv-addon="tea"]'
      );

    if (
      teaToggle &&
      teaToggle.checked
    ) {
      const teaSelect =
        modal.querySelector(
          '[data-qv-tea-variant]'
        );

      if (
        !teaSelect ||
        !teaSelect.value ||
        teaSelect.options[
          teaSelect.selectedIndex
        ].disabled
      ) {
        return {
          items: [],
          error:
            'Please choose an available Cleanse & Reset option.'
        };
      }

      items.push({
        id: Number(
          teaSelect.value
        ),
        quantity: 1
      });
    }
/* DYNAMIC UPSELL PRODUCTS */

modal
  .querySelectorAll(
    '[data-qv-dynamic-addon]:checked'
  )
  .forEach((toggle) => {
    const index =
      Number(toggle.dataset.qvDynamicAddon);

    const product =
      quickViewUpsells[index];

    const select =
      modal.querySelector(
        `[data-qv-dynamic-variant="${index}"]`
      );

    if (!product || !select || !select.value) {
      return;
    }

    const selectedOption =
      select.options[select.selectedIndex];

    if (selectedOption.disabled) {
      return;
    }

    items.push({
      id: Number(select.value),
      quantity: 1
    });
  });
    return {
      items,
      error: ''
    };
  };

  /* =====================================================
     ADD TO CART
     ===================================================== */

  const addQuickViewItem = async (
    button
  ) => {
    const modal = getQuickView();

    if (!modal) return;

    const quantityInput =
      modal.querySelector(
        '[data-quick-view-quantity]'
      );

    const message =
      modal.querySelector(
        '[data-quick-view-message]'
      );

    const quantity = Math.max(
      1,
      parseInt(
        quantityInput
          ? quantityInput.value
          : '1',
        10
      ) || 1
    );

    const cartBuild =
      buildQuickViewCartItems(
        button,
        quantity
      );

    if (cartBuild.error) {
      if (message) {
        message.textContent =
          cartBuild.error;
      }

      return;
    }

    if (!cartBuild.items.length) {
      return;
    }

    const originalText =
      button.textContent;

    button.disabled = true;

    button.textContent =
      cartBuild.items.length > 1
        ? 'Adding Routine...'
        : 'Adding to Bag...';

    if (message) {
      message.textContent = '';
    }

    try {
      const response = await fetch(
        `${root}cart/add.js`,
        {
          method: 'POST',

          headers: {
            'Content-Type':
              'application/json',

            Accept:
              'application/json'
          },

          body: JSON.stringify({
            items: cartBuild.items
          })
        }
      );

      const data =
        await response.json();

      if (!response.ok) {
        throw new Error(
          data.description ||
          data.message ||
          'Unable to add item.'
        );
      }

      button.textContent =
        cartBuild.items.length > 1
          ? 'Routine Added ✓'
          : 'Added ✓';

      if (message) {
        message.innerHTML = `
          ${
            cartBuild.items.length > 1
              ? 'Your routine was added to your bag.'
              : 'Added to your bag.'
          }

          <a href="${root}cart">
            View Bag
          </a>
        `;
      }

      document.dispatchEvent(
        new CustomEvent(
          'dollz:cart-updated',
          {
            detail: data
          }
        )
      );

      window.setTimeout(() => {
        button.disabled = false;
        button.textContent =
          originalText;
      }, 1800);

    } catch (error) {
      button.disabled = false;

      button.textContent =
        originalText;

      if (message) {
        message.textContent =
          error.message ||
          'Something went wrong. Please try again.';
      }
    }
  };

  /* =====================================================
     WISHLIST PAGE
     ===================================================== */

  const loadWishlistPage = () => {
    const container =
      document.querySelector(
        '[data-wishlist-results]'
      );

    if (!container) return;

    const saved = getWishlist();

    if (!saved.length) {
      container.innerHTML = `
        <p class="wishlist-empty">
          Your wishlist is waiting, Doll. ♡ Start saving your favorites.
        </p>
      `;

      return;
    }

    Promise.all(
      saved.map((handle) =>
        fetchProduct(handle)
          .catch(() => null)
      )
    ).then((items) => {
      const products =
        items.filter(Boolean);

      if (!products.length) {
        container.innerHTML = `
          <p class="wishlist-empty">
            Your wishlist items are no longer available.
          </p>
        `;

        return;
      }

      container.innerHTML =
        products
          .map((product) => {
            const image =
              getProductImage(product);

            const productUrl =
              product.url ||
              `${root}products/${product.handle}`;

            return `
              <article
                class="product-card"
                data-product-card
                data-product-handle="${escapeHtml(
                  product.handle
                )}"
              >

                <div
                  class="product-card__media"
                >

                  <a
                    class="product-card__image"
                    href="${escapeHtml(
                      productUrl
                    )}"
                  >
                    ${
                      image
                        ? `
                          <img
                            src="${escapeHtml(image)}"
                            alt="${escapeHtml(
                              product.title
                            )}"
                            loading="lazy"
                          >
                        `
                        : ''
                    }
                  </a>

                  ${
                    product.available
                      ? `
                        <button
                          class="product-card__quick product-card__quick--overlay"
                          type="button"
                          data-quick-view
                          data-product-handle="${escapeHtml(
                            product.handle
                          )}"
                        >
                          Quick View
                        </button>
                      `
                      : `
                        <span
                          class="product-card__soldout"
                        >
                          Sold Out
                        </span>
                      `
                  }

                </div>

                <button
                  class="wishlist-button is-saved"
                  type="button"
                  data-wishlist-handle="${escapeHtml(
                    product.handle
                  )}"
                  aria-label="Remove ${escapeHtml(
                    product.title
                  )} from saved items"
                  aria-pressed="true"
                >
                  ♡
                </button>

                <div
                  class="product-card__info"
                >

                  <span
                    class="product-card__type"
                  >
                    ${
                      product.type
                        ? escapeHtml(
                            product.type
                          )
                        : 'Saved item'
                    }
                  </span>

                  <h3>
                    <a
                      href="${escapeHtml(
                        productUrl
                      )}"
                    >
                      ${escapeHtml(
                        product.title
                      )}
                    </a>
                  </h3>

                  <span
                    class="product-card__price"
                  >
                    ${formatMoney(
                      product.price
                    )}
                  </span>

                </div>

              </article>
            `;
          })
          .join('');

      updateWishlist();
    });
  };

  /* =====================================================
     CLICK EVENTS
     ===================================================== */

  document.addEventListener(
    'click',
    (event) => {

      const menuToggle =
        event.target.closest(
          '[data-menu-toggle]'
        );

      if (menuToggle) {
        const menu =
          document.querySelector(
            '[data-mobile-menu]'
          );

        if (menu) {
          const open =
            menu.classList.toggle(
              'is-open'
            );

          menuToggle.setAttribute(
            'aria-expanded',
            String(open)
          );
        }
      }

      const wishlistButton =
        event.target.closest(
          '[data-wishlist-handle]'
        );

      if (wishlistButton) {
        event.preventDefault();

        const handle =
          wishlistButton.dataset
            .wishlistHandle;

        const saved =
  getWishlist();

const wasSaved =
  saved.includes(handle);

saveWishlist(
  wasSaved
    ? saved.filter(
        (item) =>
          item !== handle
      )
    : [...saved, handle]
);

updateWishlist();

showWishlistToast(
  wasSaved
    ? 'Removed from Wishlist'
    : '♡ Added to Wishlist'
);
      }

      const quickViewButton =
        event.target.closest(
          '[data-quick-view]'
        );

      if (quickViewButton) {
        event.preventDefault();

        openQuickView(
          quickViewButton.dataset
            .productHandle,
          quickViewButton
        );
      }

      const closeButton =
        event.target.closest(
          '[data-quick-view-close]'
        );

      if (closeButton) {
        event.preventDefault();
        closeQuickView();
      }

      const optionButton =
        event.target.closest(
          '[data-option-value]'
        );

      if (optionButton) {
        event.preventDefault();

        const group =
          optionButton.closest(
            '[data-option-index]'
          );

        if (group) {
          group
            .querySelectorAll(
              '[data-option-value]'
            )
            .forEach((button) => {
              const active =
                button ===
                optionButton;

              button.classList.toggle(
                'is-selected',
                active
              );

              button.setAttribute(
                'aria-pressed',
                String(active)
              );
            });

          updateQuickViewVariant();
        }
      }

      const routineControl =
        event.target.closest(
          '[data-qv-gear], [data-qv-addon], [data-qv-dynamic-addon]'
        );

      if (routineControl) {
        syncSpecialRoutine();
      }

      const minusButton =
        event.target.closest(
          '[data-quick-view-qty-minus]'
        );

      if (minusButton) {
        event.preventDefault();

        const modal =
          getQuickView();

        const input =
          modal &&
          modal.querySelector(
            '[data-quick-view-quantity]'
          );

        if (input) {
          input.value =
            Math.max(
              1,
              Number(
                input.value || 1
              ) - 1
            );
        }
      }

      const plusButton =
        event.target.closest(
          '[data-quick-view-qty-plus]'
        );

      if (plusButton) {
        event.preventDefault();

        const modal =
          getQuickView();

        const input =
          modal &&
          modal.querySelector(
            '[data-quick-view-quantity]'
          );

        if (input) {
          input.value =
            Number(
              input.value || 1
            ) + 1;
        }
      }

      const addButton =
        event.target.closest(
          '[data-quick-view-add]'
        );

      if (addButton) {
        event.preventDefault();

        addQuickViewItem(
          addButton
        );
      }
    }
  );

  document.addEventListener(
    'change',
    (event) => {
      if (
        event.target.matches(
          '[data-qv-gear], [data-qv-addon], [data-qv-dynamic-addon]'
        )
      ) {
        syncSpecialRoutine();
      }
    }
  );

  /* =====================================================
     KEYBOARD / ACCESSIBILITY
     ===================================================== */

  document.addEventListener(
    'keydown',
    (event) => {
      const modal =
        getQuickView();

      if (
        !modal ||
        modal.hidden
      ) {
        return;
      }

      if (event.key === 'Escape') {
        closeQuickView();
        return;
      }

      if (event.key !== 'Tab') {
        return;
      }

      const focusable =
        Array.from(
          modal.querySelectorAll(
            'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
          )
        ).filter(
          (element) =>
            !element.hasAttribute(
              'hidden'
            )
        );

      if (!focusable.length) {
        return;
      }

      const first =
        focusable[0];

      const last =
        focusable[
          focusable.length - 1
        ];

      if (
        event.shiftKey &&
        document.activeElement ===
          first
      ) {
        event.preventDefault();
        last.focus();

      } else if (
        !event.shiftKey &&
        document.activeElement ===
          last
      ) {
        event.preventDefault();
        first.focus();
      }
    }
  );

  /* =====================================================
     START
     ===================================================== */

  const startDollzTheme = () => {
    createQuickView();
    updateWishlist();
    setupGalleries();
    loadWishlistPage();
  };

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      startDollzTheme
    );
  } else {
    startDollzTheme();
  }
})();
